import styled from "styled-components";
import { smoothIn } from "../../styles/keyframes";

export const TeamBar = styled.div`
  width: 100%;
  position: sticky;
  background: white;
  z-index: 10;
  top: 0;
  transition: 0.4s;
  padding: 10px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.07);
  display: flex;
  align-items: center;
  justify-content: start;

  label {
    margin: 0 10px 0 0;
    font-size: 13.5px;
    font-weight: bold;
  }

  button {
    margin: 0 0 0 5px;
  }

  @media (max-width: 768px) {
    padding: 10px;

    label {
      display: none; // Hide label on mobile
    }
  }
`;

export const TeamBarContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 10px 0 0;

  label {
    margin: 0 10px 0 0;
    min-width: fit-content;
    font-size: 13.5px;
    font-weight: bold;
  }

  button {
    margin: 0 0 0 5px;
  }

  @media (max-width: 950px) {
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 0 0 0 0;

    label {
      margin: 0 0 10px 0;
    }

    button {
      margin: 10px 0 0 0;
    }
  }
`;

export const UserFeedback = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  width: 200px;
  background: white;
  z-index: 100;
  border-radius: 10px;
  bottom: 20px;
  right: 20px;
  min-height: 50px;
  animation: ${smoothIn} 0.6s;
  border: ${props => (props.border ? props.border : "none")};
`;
